import { IWatrTrip } from '@nkr/models/watr-trip';

export const getTripStatus = (trip: IWatrTrip): string => {
    if (trip.tripStatus === 2) {
        return 'pending';
    } else if (trip.tripStatus === 4) {
        return 'approved';
    } else if (trip.tripStatus === 100) {
        return 'declined';
    } else if (trip.tripStatus === 3) {
        return 'in_review';
    }
    return 'pending';
};

export const getStatusClass = (status: string) => {
    const statusMap: { [key: string]: string } = {
        'pending': 'trip-status-pending',
        'in_review': 'trip-status-inreview',
        'approved': 'trip-status-approved',
        'declined': 'trip-status-declined',
        'partial': 'trip-status-partial'
    };
    return statusMap[status] || 'trip-status-pending';
};

export const getStatusLabel = (status: string) => {
    const labelMap: { [key: string]: string } = {
        'pending': 'Pending',
        'in_review': 'In Review',
        'approved': 'Approved',
        'declined': 'Declined',
        'partial': 'Partial'
    };
    return labelMap[status] || 'Pending';
};

